/**
 * Marinovel 品牌 - Book 页面配置
 */
import { commonTexts } from './common'
import type { BookPageConfig } from './types'

export const theme = {
  quoteColor: 'rgba(44, 112, 255, 0.3)',
} as const

export const bookConfig: BookPageConfig = {
  theme,
  texts: commonTexts,
}
